// extracted by mini-css-extract-plugin
module.exports = {"replaceMakeOrderTabsMain":"ReplaceMakeOrderTabs_replaceMakeOrderTabsMain__2R-4n"};